import { getHomeIdentity } from "./launch-oidc.js";
import { navigate } from "./router.js";

const APP_INVITES_URL = "https://appinvites-rqfgqadjxa-ez.a.run.app";
const W2L_APP_SECRET = "yOL7/Xl3FsIHGYihibY+thG0MlTeezrqx3pONsvCODQ=";
const POLL_MS = 4000;

const AUTH_HEADERS = {
  "Content-Type": "application/json",
  "X-W2L-Secret": W2L_APP_SECRET,
};

let pollTimer = 0;
let inFlight = false;
let currentInvite = null;
let toastEl = null;

async function postInvites(body) {
  const res = await fetch(APP_INVITES_URL, {
    method: "POST",
    headers: AUTH_HEADERS,
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success !== true) {
    throw new Error(data.error || data.message || `invite_request_${res.status}`);
  }
  return data;
}

function ensureToast() {
  if (toastEl && document.body.contains(toastEl)) return toastEl;

  toastEl = document.createElement("div");
  toastEl.className = "app-invite-toast";
  toastEl.setAttribute("role", "dialog");
  toastEl.setAttribute("aria-live", "polite");
  toastEl.hidden = true;
  toastEl.innerHTML = `
    <p class="app-invite-toast-title" data-invite-toast-title></p>
    <p class="app-invite-toast-body" data-invite-toast-body></p>
    <div class="app-invite-toast-actions">
      <button type="button" class="app-invite-toast-join" data-action="invite-join">انضم</button>
      <button type="button" class="app-invite-toast-later" data-action="invite-later">لاحقاً</button>
    </div>
  `;
  document.body.appendChild(toastEl);

  toastEl.addEventListener("click", async (event) => {
    const joinBtn = event.target.closest('[data-action="invite-join"]');
    const laterBtn = event.target.closest('[data-action="invite-later"]');
    if (!joinBtn && !laterBtn) return;
    event.preventDefault();
    const invite = currentInvite;
    if (!invite) return;
    const identity = getHomeIdentity();
    hideToast();
    try {
      await postInvites({
        userId: identity.userId,
        action: joinBtn ? "accept" : "dismiss",
        inviteId: invite.id,
      });
    } catch {
      // Banner already closed; next poll will retry pending invites.
    }
    if (joinBtn && invite.appId) {
      const params = new URLSearchParams(window.location.search);
      if (invite.embedUrl) params.set("iframeUrl", invite.embedUrl);
      const query = params.toString();
      navigate(`/app/${encodeURIComponent(invite.appId)}${query ? `?${query}` : ""}`);
    }
  });

  return toastEl;
}

function hideToast() {
  currentInvite = null;
  if (!toastEl) return;
  toastEl.hidden = true;
}

function showInvite(invite) {
  const el = ensureToast();
  currentInvite = invite;
  const title = el.querySelector("[data-invite-toast-title]");
  const body = el.querySelector("[data-invite-toast-body]");
  if (title) title.textContent = invite.title || "دعوة للتطبيق";
  if (body) {
    body.textContent = invite.body || `${invite.fromName || "عضو"} يدعوك إلى ${invite.appName || "تطبيق"}`;
  }
  el.hidden = false;
}

async function pollInvites() {
  if (inFlight) return;
  const identity = getHomeIdentity();
  if (!identity.userId) return;
  if (document.visibilityState === "hidden") return;

  inFlight = true;
  try {
    const data = await postInvites({
      userId: identity.userId,
      action: "list",
    });
    const invites = Array.isArray(data.invites) ? data.invites : [];
    if (!invites.length) {
      if (!currentInvite) hideToast();
      return;
    }
    const next = invites[0];
    if (!currentInvite || currentInvite.id !== next.id) {
      showInvite(next);
    }
  } catch {
    // Keep the last visible banner; retry on the next interval.
  } finally {
    inFlight = false;
  }
}

export function startAppInviteInbox() {
  ensureToast();
  pollInvites();
  window.clearInterval(pollTimer);
  pollTimer = window.setInterval(pollInvites, POLL_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") pollInvites();
  });
}
